import { ImageElement, InnerFooter, SweetAlert } from 'components';
import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import routesMap from 'routeControl/userRouteMap';
import { setSessionStorage } from 'utils';

function LayoutThree() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [themes, setThemes] = useState({});

  const visibleFalse = () => {
    setIsAlertVisible(false);
    setThemes({});
  };

  const onConfirmAlert = () => {
    navigate(routesMap.CREATEMEMORIALS.path);
    setSessionStorage('theme', themes?.redirection[themes?.item?.imageUrl]);
  };

  const themeData = [
    {
      imageUrl: 'theme01.jpg',
    },
    {
      imageUrl: 'theme03.jpg',
    },
    {
      imageUrl: 'theme04.jpg',
    },
  ];

  const redirection = {
    'theme01.jpg': 'theme01',
    'theme02.jpg': 'theme02',
    'theme03.jpg': 'theme03',
    'theme04.jpg': 'theme04',
  };

  return (
    <>
      <main className="layoutThreePage bg-light-grey py-50 pb-0">
        <section className="pageTitle">
          <Container>
            <h1 className="fw-semibold">{t('text.common.chooseTheme')}</h1>
            <p className="mb-0">
              <p className="mb-0">{t('text.theme.craftingMoment')}</p>
            </p>
          </Container>
        </section>
        <section className="selectTheme pt-0 py-80">
          <Container>
            <Row className="g-3">
              {themeData &&
                themeData?.map((item, index) => {
                  return (
                    <>
                      <Col sm={6} lg={4} key={index}>
                        <div className="layoutCard position-relative overflow-hidden">
                          <ImageElement
                            className="w-100"
                            source={item?.imageUrl}
                          />
                          <div className="layoutCard_hoverbox d-flex align-items-center justify-content-center position-absolute top-0 start-0  w-100 h-100">
                            <Link
                              to={`/${redirection[item?.imageUrl]}`}
                              className="btn btn-white"
                            >
                              {t('text.common.livePreview')}
                            </Link>
                            <Link
                              to="#"
                              onClick={(e) => {
                                e.preventDefault();
                                setIsAlertVisible(true);
                                setThemes({ item, redirection });
                              }}
                              className="btn btn-danger"
                            >
                              {t('text.common.createMemorial')}
                            </Link>
                          </div>
                        </div>
                      </Col>
                    </>
                  );
                })}
            </Row>
          </Container>{' '}
          <SweetAlert
            reverseButtons
            title="Life Legacy"
            text="You can’t change a theme once you have added info."
            show={isAlertVisible}
            icon="warning"
            showCancelButton
            cancelButtonText="Cancel"
            confirmButtonText="Ok"
            setIsAlertVisible={() => visibleFalse()}
            showLoaderOnConfirm
            // loading={loading}
            onConfirmAlert={() => onConfirmAlert(themes)}
          />
        </section>
      </main>
      <InnerFooter />
    </>
  );
}

export default LayoutThree;
